module.exports = __webpack_public_path__ + "img/c3353ef9bfda722f06e9572b4ad91afe.otf";